// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__xhY9t","row":"ProcedureTreatmentSummary_row__2WnAP"};